import { useCallback } from "react";
import { SelectMenuItems } from "@/app/components/ui/interface";
import { useInventoryProductSearchAPI } from "@/app/hooks/api_hooks/Inventory/PO/useInventoryProductSearchAPI";

/**
 * Product (variant) search by name, the same API Inventory Audit Trail uses.
 * Resolves to select items with `vetic_variant_id` as id and `variant_name` as title.
 */
export const useGiftProductSearch = () => {
  const { execute: searchProducts } = useInventoryProductSearchAPI();

  return useCallback(
    async (query: string): Promise<SelectMenuItems> => {
      const results = (await searchProducts(query, "")) ?? [];
      return results
        .filter((product) => product?.vetic_variant_id)
        .map((product) => ({ id: product.vetic_variant_id, title: product.variant_name || product.vetic_variant_id }));
    },
    [searchProducts],
  );
};
